import "./infoEvento.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import { Col, Row, Spinner } from "react-bootstrap";
import React, { useEffect, useState } from "react";

import { Carousel } from "react-responsive-carousel";
import GoogleMaps from "simple-react-google-maps";
import ReactPlayer from "react-player";
import account from "./../../services/account";
import { useTranslation } from "react-i18next";

function InfoEvento({ evento }) {
  if (evento.ubication.gps.longitude !== "") {
    var longitud = parseFloat(evento.ubication.gps.longitude);
    var latitud = parseFloat(evento.ubication.gps.latitude);
  } else {
    longitud = 0;
    latitud = 0;
  }

  const [t, i18n] = useTranslation("global");
  const [categoria, setCategoria] = useState();
  const [email, setEmail] = useState();
  const [telefono, setTelefono] = useState();
  const [entidad, setEntidad] = useState();
  const [loading, setLoading] = useState(true);
  const [Publico, setpublico] = useState();
  if (evento.description !== "") {
    var arrayDeCadenas = evento.description.split("#");
    var descripcionEus = arrayDeCadenas[0].split("\n\n");
    var descripcionEs = arrayDeCadenas[1].split("\n\n");
  } else {
    arrayDeCadenas = [];
    descripcionEus = [];
    descripcionEs = [];
  }
  console.log(evento._id);
  useEffect(() => {
    account.infoAccount("portu@ontourup.com").then((res) => {
      setEmail(res.surnames);
      setTelefono(res.phone);
      setEntidad(res.names);
    });
    if (evento.category[0] !== "") {
      if (evento.category[0] === "talleres") {
        setCategoria(t("header.taller"));
      } else if (evento.category[0] === "teatro") {
        setCategoria(t("header.teatro"));
      } else if (evento.category[0] === "concert") {
        setCategoria(t("header.concierto"));
      } else if (
        evento.name ===
        "Vizcainos en la primera vuelta al mundo, 1519-22" || evento.name === "Bizkaitarrak lehen munduko biran,1519-22."
      ) {
        setCategoria(t("header.visita_guiada"));
      } else if (
        evento.name === "Colección permanente" || evento.name === "Bilduma iraunkorra"
      ) {
        setCategoria(t("header.visita_guiada"));
      } else if (
        evento._id === "6295c6be2af3d52a83899c3f" || evento._id === "6295c9522af3d52a8389a2de"
      ) {
        setCategoria(t("header.reportaje"));
      } else {
        setCategoria(evento.category[0]);
      }
      if (evento.tags[1] !== "") {
        setpublico(evento.tags[1]);
      }
    } else {
      setCategoria("");
      setCategoria("");
    }
    if (loading) {
      setLoading(false);
    }
  }, [evento, loading]);

  return (
    <div>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Row>
          <Col style={{ marginBottom: "50px" }}>
            <div className="descripcin montserrat-medium-thunder-25px">
              {t("header.descripcion")}
            </div>
            <div className="la-cantante-y-compos">
              {i18n.language === "es" ? (
                <div style={{ justifyContent: "center" }}>
                  {descripcionEs.map((data, key) => {
                    return (
                      <div key={key}>
                        <Row>{data}</Row>
                        <br></br>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div>
                  {descripcionEus.map((data, key) => {
                    return (
                      <div key={key}>
                        <Row>{data}</Row>
                        <br></br>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            {evento.galery.length > 0 ? (
              <>
                <div style={{ marginTop: "50px" }}>
                  <Carousel showArrows={true}>
                    {evento.galery.map((data, key) => {
                      return (
                        <div key={key}>
                          <img src={data} alt="" />
                        </div>
                      );
                    })}
                  </Carousel>
                </div>
                {evento.url.includes("youtube") ||
                  evento.url.includes("vimeo") ? (
                  <div>
                    <div className="descripcin" style={{ marginTop: "50px" }}>
                      {" "}
                      {t("header.video")}
                    </div>

                    <ReactPlayer
                      style={{ marginTop: "50px" }}
                      url={evento.url}
                      className="react-player"
                      playing={false}
                      height="360px"
                      width="auto"
                      controls
                    />
                  </div>
                ) : (
                  <div></div>
                )}
              </>
            ) : (
              <>
                {evento.url.includes("youtube") ||
                  evento.url.includes("vimeo") ? (
                  <div>
                    <div className="descripcin" style={{ marginTop: "50px" }}>
                      {" "}
                      {t("header.video")}
                    </div>

                    <ReactPlayer
                      style={{ marginTop: "50px" }}
                      url={evento.url}
                      className="react-player"
                      playing={false}
                      height="360px"
                      width="auto"
                      controls
                    />
                  </div>
                ) : (
                  <div></div>
                )}
              </>
            )}
          </Col>
          <Col style={{ marginBottom: "50px" }}>
            <div className="overlap-group1">
              <Row>
                <Col style={{ marginLeft: "20px" }}>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.genero")}
                  </div>
                  <h1 className="title">{categoria}</h1>
                </Col>

                <Col>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.idioma")}
                  </div>
                  <h1 className="title">
                    {evento.language === "Castellano"
                      ? t("header.castellano")
                      : ""}
                    {evento.language === "Euskera" ? t("header.euskera") : ""}
                    {evento.language === "Otros" ? t("header.otros") : ""}
                    {evento.language === "Bilingue" ? t("header.bilingue") : ""}
                    {evento.language === "Frances" ? t("header.frances") : ""}
                    {evento.language === "Ingles" ? t("header.ingles") : ""}
                    {evento.language === "Obra Muda"
                      ? t("header.obra-muda")
                      : ""}
                  </h1>
                </Col>
                {/* width 150pc */}
                <Col sm={6}>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.publico")}:
                  </div>              
                  {Publico === "Infantil" ? (                   
                      <h1 className="title">{Publico} / Haurren </h1>                             
                  ) : (
                    <>
                      {Publico === "Familiar" ? (                     
                          <h1 className="title">{Publico} / Familiako </h1>   
                      ) : (
                        <>
                          {Publico === "Todos" ? (
                              <h1 className="title">{Publico} / Denak </h1>                            
                          ) : (
                            <>
                              {Publico === "Adultos" ? (
                                  <h1 className="title">{Publico} / Helduak </h1>                                
                              ) : (
                                  <h1 className="title">{Publico}</h1>                                
                              )}

                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </Col>
                {evento.tags.length > 2 ? (
                  <Col>
                    <div className="ciclo-1 montserrat-medium-thunder-25px">
                      {t("header.compania")}:
                    </div>
                    <h1 className="title">{evento.tags[2]}</h1>
                  </Col>
                ) : (
                  <div></div>
                )}
              </Row>
            </div>

            <div className="ubicacionEven">
              <div style={{ width: "100%" }}>
                <div className="ubicacinEven montserrat-medium-thunder-25px">
                  {t("header.ubicacion")}
                </div>
                <div>
                  <GoogleMaps
                    apiKey={"AIzaSyCEpRrgB2-1d7Ph48KbvZmK6o7nImqSm4Q"}
                    style={{
                      height: "300px",
                      width: "auto",
                      top: "20px",
                    }}
                    zoom={15}
                    center={{
                      lat: latitud,
                      lng: longitud,
                    }}
                    markers={[{ lat: latitud, lng: longitud }]}
                  />
                </div>
                {evento.ubication.location === undefined ? (
                  <h6 className="text-3Even">{evento.location}</h6>
                ) : (
                  <h6 className="text-3Even">{evento.ubication.location}</h6>
                )}

                <p className="text-DirEven">
                  {evento.ubication.address}, {evento.ubication.postalCode}.{" "}
                </p>
                {/* <p className="text-DirEven">
                {evento.ubication.city}
                {", "}
                {evento.ubication.province}
              </p> */}
              </div>
            </div>

            <div style={{ marginTop: "40px" }} className="overlap-group1">
              <Row>
                <Col>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.Datos_organizador")}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.email")}
                  </div>
                  <h1 className="title">{email}</h1>
                </Col>
                <Col style={{ marginLeft: "20px" }}>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.telefono")}
                  </div>
                  <h1 className="title">{telefono}</h1>
                </Col>
                <Col style={{ marginLeft: "20px" }}>
                  <div className="ciclo-1 montserrat-medium-thunder-25px">
                    {t("header.entidad")}
                  </div>
                  <h1 className="title">{entidad}</h1>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default InfoEvento;
